import { useMemo } from 'react'
import useGlobalState from '../hooks/useGlobalState'

export default function Logger() {
    const log = useGlobalState((state) => state.log)
    const s = useMemo(() => log.join('\n'), [log])
    return <pre>{s}</pre>
}
